// ============================================================================
// VANITY PRICING  (QAR)
// AUTO-GENERATED from countertops.xls / storages.xls (Cabina price list,
// updated 11 May 2026). Exact per-SKU prices - do not hand-edit; regenerate
// from the source sheets when prices change.
//
// Countertops have two price tiers driven by the chosen finish:
//   base    - Solid / Sanded / Aspen colours
//   supreme - Terrazzo / Supreme colours
// Storage has a single price per SKU.
// ============================================================================

import { countertopColors } from "./vanityColors.js";

const COUNTERTOP_PRICES = {
  "1C.U1.80": {"base": 1805, "supreme": 2130},
  "1C.U1.100": {"base": 2060, "supreme": 2450},
  "1C.U1.120": {"base": 2380, "supreme": 2850},
  "1C.U1.180": {"base": 3065, "supreme": 3665},
  "1C.U1A.180": {"base": 3065, "supreme": 3665},
  "2C.U1.180": {"base": 3845, "supreme": 4615},
  "1C.U2.80": {"base": 1805, "supreme": 2130},
  "1C.U2.100": {"base": 2060, "supreme": 2450},
  "1C.U2.120": {"base": 2380, "supreme": 2850},
  "1C.U2.180": {"base": 3065, "supreme": 3665},
  "2C.U2.180": {"base": 3845, "supreme": 4615},
  "1S.U1.80": {"base": 1805, "supreme": 2130},
  "1S.U1.100": {"base": 2060, "supreme": 2450},
  "1S.U1.120": {"base": 2380, "supreme": 2850},
  "1S.U1A.180": {"base": 3065, "supreme": 3665},
  "2S.U1.180": {"base": 3845, "supreme": 4615},
  "1S.U2.80": {"base": 1805, "supreme": 2130},
  "1S.U2.100": {"base": 2060, "supreme": 2450},
  "1S.U2.120": {"base": 2380, "supreme": 2850},
  "1S.U2A.180": {"base": 3065, "supreme": 3665},
  "2S.U2.180": {"base": 3845, "supreme": 4615},
  "1C.U2A.180": {"base": 3065, "supreme": 3665}
};

const STORAGE_PRICES = {
  "1C.C1.0.80": 1180,
  "1C.C1.0.100": 1455,
  "1C.C1.0.120": 1725,
  "1C.D2.0.80": 1270,
  "1C.D2.0.100": 1545,
  "1C.D2.0.120": 1815,
  "1C.D1.S1.80": 1210,
  "1C.D1.S1.100": 1480,
  "1C.D1.S1.120": 1750,
  "1C.C2.S2.180": 2469,
  "1C.D4.S2.180": 3089,
  "1C.D4.0.180": 2870,
  "1C.D2.S2.180": 2780,
  "1S.C1.0.80": 1180,
  "1S.C1.0.100": 1455,
  "1S.C1.0.120": 1725,
  "1S.D2.0.80": 1270,
  "1S.D2.0.100": 1545,
  "1S.D2.0.120": 1815,
  "1S.D1.S1.80": 1210,
  "1S.D1.S1.100": 1480,
  "1S.D1.S1.120": 1750,
  "1S.D4.0.180": 2870,
  "1S.D2.S2.180": 2780,
  "2C.D1.0.80": 1155,
  "2C.D2.0.100": 1350,
  "2C.D2.0.120": 1840,
  "2C.D3.0.180": 2280,
  "3C.0.0.80": 895,
  "3C.0.0.100": 1025,
  "3C.0.0.120": 1280,
  "3C.0.0.180": 1530
};

// The price tier comes from the colour catalogue itself (single source of
// truth) - a finish tagged "supreme" (Terrazzo / Supreme) uses the higher tier.
const GROUP_BY_ID = new Map(countertopColors.map((c) => [c.id, c.group]));

export function countertopColorGroup(colorId) {
  return GROUP_BY_ID.get(colorId) === "supreme" ? "supreme" : "base";
}

export function countertopPrice(counter, colorId) {
  if (!counter) return 0;
  const row = COUNTERTOP_PRICES[counter.id];
  if (!row) return 0;
  return row[countertopColorGroup(colorId)] ?? row.base;
}

export function storagePrice(storage) {
  if (!storage) return 0; // "No Storage"
  return STORAGE_PRICES[storage.id] ?? 0;
}

export function vanityTotal({ counter, storage, countertopColorId }) {
  return countertopPrice(counter, countertopColorId) + storagePrice(storage);
}

// Exported for tooling / verification.
export { COUNTERTOP_PRICES, STORAGE_PRICES };
